import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { LoginForm as CoreLoginForm } from '@/Core/Components/Auth/LoginForm'
import { useNotification } from '@/Ship/Hooks/useNotification'
import { userManager } from '@/Core/Managers'
import { AppConfig } from '@/Ship/Configs/AppConfig'

import { FormWrapper } from '../FormWrapper'

const NS = 'Public.Auth'

/** Автофокус на телефоні лише з мишею/трекпадом — на сенсорних не піднімати клавіатуру одразу */
const hasFinePointer = (): boolean =>
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(pointer: fine)').matches

export const LoginForm = () => {
    const { t } = useTranslation()
    const { showError } = useNotification()
    const navigate = useNavigate()

    // Форму показує і сторінка входу, і Core замість будь-якого розділу, коли користувач
    // не авторизований (templateError403) — тоді шаблон layout-а не рендериться і
    // назву вкладки треба поставити тут.
    useEffect(() => {
        document.title = t('Authorization', { ns: NS })
    }, [t])

    const handleSuccess = () => {
        if (userManager.hasRole('ROLE_DRIVER')) {
            navigate('/driver', { replace: true })
        } else {
            navigate('/', { replace: true })
        }
    }

    // TODO: `loginFieldProps`/`passwordFieldProps` are consumed by Core's LoginForm but missing
    // from LoginFormProps (Core type bug). Passed via cast until the Core type declares them.
    const fieldProps = {
        loginFieldProps: {
            type: 'phone-login',
            inputProps: { autoComplete: 'username', autoFocus: hasFinePointer() },
        },
        // Core's PasswordInput hardcodes autoComplete="new-password"; for login the browser
        // password manager needs "current-password" to offer saved credentials.
        passwordFieldProps: {
            inputProps: { autoComplete: 'current-password' },
        },
    } as Record<string, unknown>

    return (
        <FormWrapper
            title={t('Sign in', { ns: NS })}
            subtitle={t('Enter your phone number and password to continue.', { ns: NS })}
        >
            <CoreLoginForm
                forgotPasswordPageUrl={AppConfig.forgotPasswordPageUrl}
                onError={(title, message) => showError(title, message)}
                loginFieldLabel={t('Phone', { ns: NS })}
                {...fieldProps}
                onSuccess={handleSuccess}
            />
        </FormWrapper>
    )
}
